import { kiwiGreen, sanguine, spaceCadet } from '@cogneed/react-utils';
import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  backgroundColor: 'white',
  borderTop: `1px solid ${spaceCadet[300]}`,
  padding: '8px 16px',

  '& > .MuiTypography-subtitle1': {
    fontSize: 14,
    lineHeight: '20px',
  },

  '& .number': {
    padding: '0px 4px',
    borderRadius: 4,
    color: kiwiGreen[100],
    backgroundColor: kiwiGreen[600],
    '&.negative': {
      color: sanguine[100],
      backgroundColor: sanguine[600],
    },
  },

  '& > .MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4,
    gap: 4,
    '& [data-step-number]:not(.step-number)': {
      padding: '0px 4px',
      borderRadius: 4,
    },

    '& .MuiTypography-body1': {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 700,
    },
  },
});

export default StyledBox;
